// All needed imports
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { LogService } from '../errors/log.service';

/**
 * Console Utils class
 */
@Injectable()
export class ConsoleUtils {
    /**
     * @description overrideConsoleMethods
     */
    static overrideConsoleMethods: () => void = (): void => {
        const showForbiddenMsg: (oldCons: Console) => void = (oldCons: Console): void => {
            oldCons.log('%cPor su seguridad, hemos deshabilitado la consola!',
                'color: red; font-family: sans-serif; font-size: 2em; font-weight: bolder; text-shadow: #000 1px 1px;');
            oldCons.log('%c ',
            'font-size:400px;' +
            'background:url("http://t3.gstatic.com/images?q=tbn:ANd9GcTqeOHYBm0i7Oeny8APKfIY8c5A_Q0nvGKch_LZNil3RWUlwrJT");' +
            ' background-size:contain; background-repeat:no-repeat');

        };
        const console: any = ((oldCons: Console) => {
            return {
                log(): void {
                    showForbiddenMsg(oldCons);
                },
                info(): void {
                    showForbiddenMsg(oldCons);
                },
                warn(): void {
                    showForbiddenMsg(oldCons);
                },
                error(): void {
                    showForbiddenMsg(oldCons);
                },
                memory(): void {
                    showForbiddenMsg(oldCons);
                },
                assert(): void {
                    showForbiddenMsg(oldCons);
                },
                clear(): void {
                    showForbiddenMsg(oldCons);
                },
                count(): void {
                    showForbiddenMsg(oldCons);
                },
                countReset(): void {
                    showForbiddenMsg(oldCons);
                },
                debug(): void {
                    showForbiddenMsg(oldCons);
                },
                dir(): void {
                    showForbiddenMsg(oldCons);
                },
                dirxml(): void {
                    showForbiddenMsg(oldCons);
                },
                exception(): void {
                    showForbiddenMsg(oldCons);
                },
                group(): void {
                    showForbiddenMsg(oldCons);
                },
                groupCollapsed(): void {
                    showForbiddenMsg(oldCons);
                },
                groupEnd(): void {
                    showForbiddenMsg(oldCons);
                },
                table(): void {
                    showForbiddenMsg(oldCons);
                },
                time(): void {
                    showForbiddenMsg(oldCons);
                },
                timeEnd(): void {
                    showForbiddenMsg(oldCons);
                },
                timeLog(): void {
                    showForbiddenMsg(oldCons);
                },
                timeStamp(): void {
                    showForbiddenMsg(oldCons);
                },
                trace(): void {
                    showForbiddenMsg(oldCons);
                },
                profile(): void {
                    showForbiddenMsg(oldCons);
                },
                profileEnd(): void {
                    showForbiddenMsg(oldCons);
                }
            };
        })(window.console);
        (window as any).console = console;
    }
    /**
     * @description overrideAlertMethods
     */
    static overrideAlertMethods: () => void = (): void => {
        // const msgDisabled = 'Por su seguridad, esta función está deshabilitada';
        // window.alert = () => { console.log(); };
        window.confirm = null;
        window.prompt = null;
    }
}
